<template>
  <div id="app">
    <loader
      v-if="isLoading"
      style="height: 100vh;"/>
    <template v-if="!userIsCoachOrAdmin || !userAuthToken">
      <vertically-centered-container style="min-height: 60vh;">
        <login-page/>
      </vertically-centered-container>
    </template>
    <template v-else>
      <top-menu/>
      <div class="ui container">
        <router-view/>
        <div style="height: 5em"/>
      </div>
    </template>
  </div>
</template>

<script>
import Loader from './components/Loader'
import TopMenu from './components/TopMenu'
import LoginPage from './views/LoginPage'
import { mapState, mapMutations, mapActions } from 'vuex'
import VerticallyCenteredContainer from './components/utility/VerticallyCenteredContainer'
import { getCoaches } from './forms/fields'
import { deleteAllCookies } from './mixins/cookies'

// Questionnaire Authentication
let maximumAttempts = 10
let attempts = 1

const pause = delay => new Promise(resolve => setTimeout(resolve, 500))

export default {
  name: 'App',
  components: {
    VerticallyCenteredContainer,
    Loader,
    TopMenu,
    LoginPage
  },
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapState(['userAuthToken', 'userIsCoachOrAdmin'])
  },
  created () {
    this.authorizeQuestionnaireAxios()
    this.setCredentialsFromCookies()
  },
  mounted () {
    this.fetchAndSetCoaches()
  },
  methods: {
    ...mapMutations(['setUser']),
    ...mapActions(['saveCoaches']),

    parseCookies () {
      let cookies = document.cookie.split('; ')

      let output = {}

      cookies.forEach(string => {
        let divider = string.search('=')

        let key = string.slice(0, divider)
        let value = string.slice(divider + 1)

        output[key] = value
      })
      return output
    },
    setCredentialsFromCookies () {
      let cookies = this.parseCookies()

      if (
        cookies.hasOwnProperty('migraineCare_xiG1Zg2MW5_UserId') &&
        cookies.hasOwnProperty('migraineCare_xiG1Zg2MW5_UserEmail') &&
        cookies.hasOwnProperty('migraineCare_xiG1Zg2MW5_UserAuthToken') &&
        cookies.hasOwnProperty('migraineCare_xiG1Zg2MW5_UserIsCoachOrAdmin')
      ) {
        this.setUser(
          {
            userId: cookies.migraineCare_xiG1Zg2MW5_UserId,
            userEmail: cookies.migraineCare_xiG1Zg2MW5_UserEmail,
            userAuthToken: cookies.migraineCare_xiG1Zg2MW5_UserAuthToken,
            userIsCoachOrAdmin: cookies.migraineCare_xiG1Zg2MW5_UserIsCoachOrAdmin === 'true'
          }
        )
      } else {
        deleteAllCookies()
      }
    },
    fetchAndSetCoaches () {
      if (this.userIsCoachOrAdmin || this.userAuthToken) {
        getCoaches().then(this.saveCoaches)
      }
    },
    authorizeQuestionnaireAxios () {
      return new Promise(
        (resolve, reject) => {
          if (this.$qnAxios.defaults.headers.hasOwnProperty('Authorization')) {
            resolve(true)
          } else {
            let jwtBody = {
              username: process.env.VUE_APP_QUESTIONNAIRE_USER,
              password: process.env.VUE_APP_QUESTIONNAIRE_PASSWORD
            }

            this.$qnAxios.post(`/auth`, jwtBody)
              .then(
                ({ data }) => {
                  this.$qnAxios.defaults.headers['Authorization'] = `jwt ${data.token}`
                  resolve(data.token)
                },
                async ({ response }) => {
                  while (attempts < maximumAttempts) {
                    attempts++
                    await pause(300)
                    await this.authorizeQuestionnaireAxios()
                  }
                  reject(response)
                }
              )
              .catch(
                error => {
                  if (attempts === maximumAttempts) {
                    this.$rollbar.warning('Failed to fetch and set JWT Token for questionnaire axios instance', error)
                  }
                }
              )
          }
        }
      )
    }
  }
}
</script>
